var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2489.2 2487.6",
    style: {
      enableBackground: "new 0 0 2489.2 2487.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34313F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1311.5,1416.2h314c89.3,0,145.8-49.1,145.8-128c0-74.4-56.5-128-145.8-128h-314c-10.4,0-19.3,8.9-19.3,17.9 v220.2C1293.6,1408.7,1301,1416.2,1311.5,1416.2z M1311.5,1923.6h324.4c99.7,0,159.2-50.6,159.2-139.9 c0-77.4-56.5-139.9-159.2-139.9h-324.4c-10.4,0-19.3,8.9-19.3,17.9v242.6C1293.6,1916.2,1301,1923.6,1311.5,1923.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2460.3,5.5l-928.6,925.6h151.8c236.6,0,376.5,148.8,376.5,311c0,128-86.3,221.7-178.6,263.4 c-14.9,6-14.9,26.8,1.5,32.7c107.1,41.7,183,153.3,183,284.2c0,184.5-123.5,331.8-363.1,331.8h-657.7c-10.4,0-19.3-8.9-19.3-17.9 v-700.9L6.4,2450.4c-13.4,13.4-4.5,37.2,14.9,37.2h2450.9c8.9,0,16.4-7.4,16.4-16.4V18.9C2493,2.5,2472.2-6.4,2460.3,5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcommerce);
export default __webpack_public_path__ + "static/media/bigcommerce.cf5405b47fe8fb57532ddfd3708b5445.svg";
export { ForwardRef as ReactComponent };